import { Link } from "react-router-dom";
import { Phone } from "lucide-react";

const navLinks = [
  { href: "/", label: "Acasă" },
  { href: "/pachete", label: "Pachete" },
  { href: "/servicii", label: "Servicii" },
  { href: "/b2b", label: "B2B: Externalizare WP" },
  { href: "/despre", label: "Despre" },
  { href: "/faq", label: "FAQ" },
  { href: "/contact", label: "Contact" },
];

const legalLinks = [
  { href: "/politica-confidentialitate", label: "Politică de confidențialitate" },
  { href: "/termeni-conditii", label: "Termeni și condiții" },
  { href: "/politica-cookies", label: "Politică cookies" },
];

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-[#0A1118] text-white">
      <div className="section-container py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <img src={`${import.meta.env.BASE_URL}images/ordell-logo.png`} alt="Ordell WebCare" className="w-7 h-7" width="28" height="28" loading="lazy" />
              <span className="font-['Outfit'] font-bold text-xl text-white">Ordell</span>
              <span className="font-['Outfit'] font-light text-xl text-[#4A9E96]">WebCare</span>
            </Link>
            <p className="text-white/60 text-sm leading-relaxed">
              Mentenanță și suport WordPress pentru business-uri care vor stabilitate, claritate și liniște operațională.
            </p>
          </div>

          <div>
            <h4 className="font-['Outfit'] font-semibold text-sm tracking-wider uppercase text-white/60 mb-4">
              Navigare
            </h4>
            <nav className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  data-testid={`footer-nav-${link.label.toLowerCase()}`}
                  className="text-sm text-white/60 hover:text-white transition-colors"
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          <div>
            <h4 className="font-['Outfit'] font-semibold text-sm tracking-wider uppercase text-white/60 mb-4">
              Legal
            </h4>
            <nav className="flex flex-col gap-3">
              {legalLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  data-testid={`footer-legal-${link.label.toLowerCase().replace(/\s/g, '-')}`}
                  className="text-sm text-white/60 hover:text-white transition-colors"
                >
                  {link.label}
                </Link>
              ))}
              <button
                type="button"
                data-cc="show-preferencesModal"
                data-testid="footer-cookie-settings"
                className="text-sm text-white/60 hover:text-white transition-colors text-left"
              >
                Setări cookie
              </button>
            </nav>
          </div>

          <div>
            <h4 className="font-['Outfit'] font-semibold text-sm tracking-wider uppercase text-white/60 mb-4">
              Contact
            </h4>
            <div className="flex items-center gap-2 mb-3">
              <Phone className="w-4 h-4 text-white/60" />
              <a href="tel:+40734311307" className="text-sm text-white/60 hover:text-white transition-colors">
                +40 (734) 311 307
              </a>
            </div>
            <a
              href="https://wa.me/40734311307"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-white transition-colors mb-4"
            >
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
              WhatsApp
            </a>
            <p className="text-xs text-white/60">
              Luni - Vineri, 11:00 - 19:00
            </p>
            <Link
              to="/contact"
              data-testid="footer-cta-btn"
              className="inline-flex bg-white text-[#0F2942] font-medium text-sm px-5 py-2.5 rounded-xl hover:bg-white/90 transition-all mt-4"
            >
              Cere audit gratuit
            </Link>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/60">
            &copy; {new Date().getFullYear()} Ordell WebCare. Toate drepturile rezervate.
          </p>
          <div className="flex items-center gap-4">
            <a href="https://anpc.ro/" target="_blank" rel="noopener noreferrer">
              <img src={`${import.meta.env.BASE_URL}images/anpc-sal.png`} alt="ANPC - Soluționarea Alternativă a Litigiilor" className="h-10" width="120" height="40" loading="lazy" />
            </a>
            <a href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=RO" target="_blank" rel="noopener noreferrer">
              <img src={`${import.meta.env.BASE_URL}images/sol-online.png`} alt="Soluționarea Online a Litigiilor" className="h-10" width="120" height="40" loading="lazy" />
            </a>
          </div>
          <p className="text-xs text-white/60">
            SC Maze Digital SRL<br />CUI: RO38272886
          </p>
        </div>
      </div>
    </footer>
  );
}
